// Auto-generated cornerstone translation for ar.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:19:44.015222+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "تطبيق إدارة الخيول: أفضل اختيار لعام 2026 | EquiSight",
      description: "قارن تطبيقات إدارة الخيول للمالك والإسطبل ومزارع التربية. اكتشف لماذا يُعدّ EquiSight التطبيق الشامل لخيلك.",
      keywords: [
        "تطبيق إدارة الخيول",
        "تطبيق إدارة الإسطبل",
        "تطبيق سجل الخيول",
        "تطبيق إدارة عدة خيول",
        "تطبيق حمل الفرس",
        "تطبيق تربية الخيول",
        "أفضل تطبيق إدارة خيول",
      ],
    },
    hero: {
      eyebrow: "دليل الاختيار · برنامج إدارة الخيول",
      breadcrumbLabel: "تطبيق إدارة الخيول",
      title: "تطبيق إدارة الخيول: الدليل الشامل للاختيار للملّاك والإسطبلات ومزارع التربية.",
      intro: "ليست مجرد قائمة مميزات — بل مقارنة صادقة ودليل اختيار ونظرة على ما يجب أن يتمكن منه تطبيق إدارة الخيول فعلاً في عام 2026. لخيل واحد، أو لإسطبل كامل، أو لمزرعة التربية الخاصة بك.",
      pills: [
        {
          icon: "Users",
          label: "للملّاك",
        },
        {
          icon: "Building2",
          label: "للإسطبلات",
        },
        {
          icon: "Baby",
          label: "لمزارع التربية",
        },
        {
          icon: "Share2",
          label: "للفرق",
        },
      ],
      ctas: [
        {
          label: "ابدأ مجاناً بخيل واحد",
          href: "#start",
          primary: true,
        },
        {
          label: "إلى جدول المقارنة",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "لماذا يصبح تطبيق إدارة الخيول أكثر أهمية يوماً بعد يوم.",
      lead: "إدارة الخيول في الواقع العملي متشتتة: WhatsApp والمفكرة و Excel وصور على هاتفك وجواز سفر ورقي وفواتير منفصلة واتفاقيات شفهية. أمر غير عملي حتى مع خيل واحد. مع عدة خيول أو مزارع تربية أو رعاية مشتركة، تظهر الثغرات والمواعيد الفائتة والخلافات.",
      items: [
        "أين كان تاريخ التطعيم ذلك؟",
        "من دفع لبيطار الحوافر؟",
        "أي فرس يجب فحصها اليوم؟",
        "هل قرأ المدرب تعليمات الأسبوع الماضي؟",
        "هل حفظت ذلك المستند الصوري فعلاً؟",
        "هل جدول التغذية المعلق في الإسطبل لا يزال صحيحاً؟",
      ],
    },
    what: {
      title: "ما هو تطبيق إدارة الخيول؟",
      lead: "تطبيق إدارة الخيول هو في جوهره ملف رقمي لكل خيل. لا ملاحظات متشتتة، بل مكان واحد للصحة والتدريب والتغذية والوثائق والتخطيط والتذكيرات والتكاليف والصور والفيديوهات والوصول المشترك. الجميع من حول الخيل ينظر إلى نفس المعلومات المحدّثة.",
      targetGroupsTitle: "لمن يُخصَّص تطبيق إدارة الخيول؟",
      targetGroups: [
        {
          icon: "Heart",
          title: "المالك الخاص",
          body: "خيل واحد وملف واحد — الصحة والتخطيط والسجل التاريخي في جيبك.",
        },
        {
          icon: "Users",
          title: "مالك عدة خيول",
          body: "ملفات منفصلة وتخطيط منفصل وقائمة مهام مشتركة للفريق بأكمله.",
        },
        {
          icon: "Building2",
          title: "إسطبل إيواء وحلبة فروسية",
          body: "وصول المالك وتعليمات الرعاية وجدول أعمال مشترك ومهام.",
        },
        {
          icon: "Baby",
          title: "مزرعة التربية",
          body: "دورة الفرس والحمل وبيانات الحصان والشجرة النسبية وتطور المهر.",
        },
        {
          icon: "Target",
          title: "المدربون",
          body: "متابعة كل خيل على حدة وتسجيل الجلسات وتحديد الأهداف وتحليل الفيديوهات.",
        },
        {
          icon: "ClipboardList",
          title: "المتخصصون",
          body: "بيطار الحوافر وطبيب الأسنان والمعالج الفيزيائي والطبيب البيطري — جميعهم يعملون من نفس الملف.",
        },
      ],
    },
    criteria: {
      title: "ما المعايير التي يجب أن يستوفيها تطبيق جيد لإدارة الخيول؟",
      lead: "التطبيق ليس جميلاً فحسب — بل يجب أن يعمل بشكل عملي يومياً. خمسة عناصر لا يجوز إغفالها عند الاختيار في عام 2026.",
      items: [
        {
          icon: "FileText",
          title: "ملف الخيل لكل فرد",
          body: "البيانات والعمر والسلالة ومعلومات جواز السفر والمالك والإسطبل والصور والوثائق — كلها مرتبطة بملف خيل واحد.",
        },
        {
          icon: "Heart",
          title: "الصحة والرعاية",
          body: "التطعيمات وإزالة الطفيليات وبيطار الحوافر وطبيب الأسنان والطبيب البيطري والعلاجات والأدوية والتذكيرات التلقائية قبل تاريخ الانتهاء.",
        },
        {
          icon: "Activity",
          title: "التدريب والتقدم",
          body: "تسجيل جلسات التدريب والملاحظات والفيديوهات ونتائج المسابقات والأهداف والتقدم لكل تخصص أو لكل خيل.",
        },
        {
          icon: "Apple",
          title: "التغذية والإدارة",
          body: "جداول التغذية والمكملات والعلف الخشن والوزن وحالة الجسم والروتين اليومي الذي يجب أن يعرفه الإسطبل.",
        },
        {
          icon: "Share2",
          title: "المشاركة مع الآخرين",
          body: "وصول للمالك والمشرف والمدرب وصاحب الإسطبل أو المتخصص — مع إدارة صلاحيات تناسب دور كل شخص.",
        },
        {
          icon: "Calendar",
          title: "التخطيط والتذكيرات",
          body: "جدول أعمال مشترك بمهام وتذكيرات تلقائية وتأكيدات حتى لا يفوت شيء.",
        },
      ],
    },
    comparison: {
      title: "EquiSight مقارنةً بتطبيقات إدارة الخيول الأخرى.",
      lead: "تملأ السوق حالياً تطبيقات Stalmanager وLogMyHorse وEquineM وHappie Horse. لكل منها نقاط قوة. نضع أكثر الميزات طلباً جنباً إلى جنب بصدق وبناءً على المعلومات المتاحة للعموم.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "بداية مجانية",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "عدة خيول",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "ملف صحي",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "التدريب والتقدم",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "التغذية والمكملات",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "التخطيط والتذكيرات",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "وثائق لكل خيل",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "المشاركة مع الفريق والصلاحيات",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "وحدة التربية (كاملة)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "دورة الفرس",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "تخطيط الحمل + الفحص بالموجات",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "تطور المهر",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "دمج المتخصصين",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "رؤى EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "مناسب للمالك",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "مناسب لمزارع التربية",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "مناسب للإسطبل/حلبة الفروسية",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "المقارنة مبنية على الميزات المتاحة للعموم في يناير 2026. المنافسون أيضاً أدوات جيدة؛ بُني EquiSight لدمج جميع الوحدات في تطبيق واحد.",
    },
    why: {
      title: "لماذا يختلف EquiSight عن غيره.",
      lead: "السجل يُوثّق فحسب. أما EquiSight فيجمع إدارة الخيول والتدريب والتغذية والصحة والمسابقات والمتخصصين والتربية في تطبيق حديث واحد — ويتخطى ذلك بتقديم رؤى واضحة.",
      points: [
        {
          icon: "Heart",
          title: "تطبيق واحد لكامل حياة الخيل",
          body: "من المهر إلى الخيل الرياضي أو فرس التربية أو خيل التقاعد. يتطور الملف مع خيلك — لا شيء يضيع في الطريق.",
        },
        {
          icon: "Sparkles",
          title: "ليس بيانات فقط، بل أنماط أيضاً",
          body: "يجمع EquiCoach التطور والشكاوى المتكررة والتدريب والتغذية — حتى ترى الإشارات في الوقت المناسب، لا مجرد تنبيهات منفصلة.",
        },
        {
          icon: "Share2",
          title: "مبني للتعاون",
          body: "المالك وصاحب الإسطبل والمدرب وبيطار الحوافر والمتخصصون الآخرون يعملون من نفس ملف الخيل — بالصلاحيات التي تناسب دور كل منهم.",
        },
      ],
    },
    nicheA: {
      eyebrow: "تخصص · التربية",
      title: "إدارة الخيول لمزارع التربية.",
      lead: "يذكر كثير من المنافسين التربية في سطر واحد. بنى EquiSight وحدة تربية متكاملة — لأن المربّي نادراً ما يكون المستخدم النهائي لتطبيق عام، غير أنه يحتاج إلى التخطيط أكثر من أي شخص آخر.",
      items: [
        "متابعة دورة الفرس يومياً",
        "تاريخ التلقيح + بيانات الحصان",
        "مراقبة الحمل بالفحص بالموجات",
        "تاريخ الولادة المتوقع + تنبيهات",
        "تطور المهر شهراً بشهر",
        "شجرة النسب والأصل",
        "ملاحظات لكل فرس",
        "نظرة عامة على جميع الفرسان الحوامل",
      ],
      ctaLabel: "استعرض وحدة التربية",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "تخصص · الإسطبل وحلبة الفروسية",
      title: "إدارة الخيول لعدة خيول وإسطبلات الإيواء.",
      lead: "مع عدة خيول، يصبح الأمر أقل تعلقاً بالبيانات وأكثر ارتباطاً بالتواصل. لكل مالك رغباته وروتينه واتفاقيات تغذيته ونقاط اهتمامه الطبية الخاصة. ويجب أن يتمكن كل موظف من الوصول إلى ذلك دون بحث.",
      cards: [
        {
          t: "الخيول لكل مالك",
          d: "كل مالك يرى خيله (خيوله) فقط.",
        },
        {
          t: "تعليمات الرعاية",
          d: "مرئية لكل خيل في الإسطبل.",
        },
        {
          t: "جدول أعمال مشترك",
          d: "بيطار الحوافر والطبيب البيطري والمسابقات في عرض واحد.",
        },
        {
          t: "قائمة المهام",
          d: "تُسند للموظفين مع تأكيد.",
        },
        {
          t: "وصول المالك",
          d: "يرى العملاء خيلهم في تطبيقهم الخاص.",
        },
        {
          t: "جهات الاتصال في الطوارئ",
          d: "دائماً في متناول اليد عند الأزمات في الإسطبل.",
        },
      ],
      ctaLabel: "استعرض وحدة الحلبة",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "من WhatsApp و Excel واللوح الأبيض إلى EquiSight.",
      lead: "بشكل ملموس: هكذا تتغير إدارتك اليومية للخيول.",
      rows: [
        {
          before: "مجموعات WhatsApp",
          after: "ملاحظات منظمة لكل خيل",
        },
        {
          before: "جداول Excel",
          after: "ملف خيل حي مع السجل التاريخي",
        },
        {
          before: "اللوح الأبيض في الإسطبل",
          after: "تخطيط مشترك على هاتفك",
        },
        {
          before: "صور منفصلة على الكاميرا",
          after: "وسائط مرتبطة بخيلك",
        },
        {
          before: "اتفاقيات شفهية",
          after: "مهام وتذكيرات مع تأكيد",
        },
        {
          before: "جواز سفر ورقي ضائع",
          after: "وثائق في متناول يدك دائماً",
        },
      ],
    },
    helper: {
      title: "أي تطبيق إدارة خيول يناسبك؟",
      lead: "أجب على هذه الأسئلة الخمسة وستحصل على توصية صادقة — حتى لو لم تكن دائماً EquiSight.",
      questions: [
        {
          id: "horses",
          q: "هل تمتلك خيلاً واحداً أم عدة خيول؟",
          options: [
            {
              label: "خيل واحد",
              score: 1,
            },
            {
              label: "2–5 خيول",
              score: 2,
            },
            {
              label: "أكثر من 5 خيول",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "هل تدير خيول عملاء أو أطراف أخرى؟",
          options: [
            {
              label: "لا، خيولي الخاصة فقط",
              score: 0,
            },
            {
              label: "أحياناً — للعائلة أو المعارف",
              score: 1,
            },
            {
              label: "نعم، بشكل احترافي (إسطبل / حلبة)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "هل تريد متابعة التربية والحمل؟",
          options: [
            {
              label: "غير ذي صلة",
              score: 0,
            },
            {
              label: "أحياناً — تربية عرضية",
              score: 1,
            },
            {
              label: "نعم، أنا مربٍّ (أو سأصبح مربياً)",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "هل تتعاون مع مدرب أو مشرف أو متخصص؟",
          options: [
            {
              label: "لا، أتولى كل شيء بنفسي",
              score: 0,
            },
            {
              label: "نعم، مع شخص واحد",
              score: 1,
            },
            {
              label: "نعم، مع عدة أشخاص",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "هل تريد التوثيق فقط أم الحصول على رؤى أيضاً؟",
          options: [
            {
              label: "التوثيق فقط",
              score: 1,
            },
            {
              label: "التوثيق + التخطيط",
              score: 2,
            },
            {
              label: "التوثيق + التخطيط + الرؤى",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "سجل بسيط يكفي — وسيتطور معك.",
          body: "لخيل واحد دون رعاية مشتركة، أي تطبيق إدارة خيول مناسب. يبدأ EquiSight مجاناً بخيل واحد، لذلك لا خطر عليك. وإن أردت لاحقاً إضافة خيول أو مدرب أو تربية، فكل شيء موجود بالفعل.",
          cta: "ابدأ مجاناً بخيل واحد",
        },
        mid: {
          title: "EquiSight يناسب وضعك تماماً.",
          body: "لديك احتياجات متعددة (عدة خيول أو تعاون أو رؤى). معظم المنافسين يغطون وحدة أو وحدتين؛ EquiSight يجمعها في تطبيق واحد دون الحاجة إلى ربط أدوات منفصلة.",
          cta: "اكتشف ما يمكن لـ EquiSight فعله",
        },
        high: {
          title: "EquiSight هو الخيار الأكثر منطقية.",
          body: "يجمع وضعك بين عدة خيول والتعاون والتربية و/أو الرؤى. هذا بالضبط هو المكان الذي يصنع فيه EquiSight الفارق — لا أدوات متشتتة، بل ملف خيل واحد لكل شيء ولكل من حول الخيل.",
          cta: "ابدأ مجاناً مع EquiSight",
        },
      },
    },
    faqTitle: "أسئلة شائعة حول تطبيقات إدارة الخيول",
    faq: [
      {
        q: "ما هو أفضل تطبيق لإدارة الخيول؟",
        a: "يعتمد أفضل تطبيق لإدارة الخيول على وضعك. لمجرد سجل بسيط، تصلح عدة تطبيقات. إن أردت الجمع بين الصحة والتدريب والتغذية والوثائق والتربية والتخطيط والتعاون، فقد بُني EquiSight كحل شامل يجمع كل شيء في ملف واحد.",
      },
      {
        q: "هل يمكنني إدارة عدة خيول في تطبيق واحد؟",
        a: "نعم. يجب أن يدعم تطبيق جيد لإدارة الخيول عدة خيول، بما يشمل الملّاك والمشرفين والروتين والوثائق والمواعيد والتذكيرات لكل خيل. صُمِّم EquiSight على هذا الأساس منذ السطر الأول من الكود — الخيول ملفات فردية، لا صفوف في قائمة.",
      },
      {
        q: "هل EquiSight مناسب لمزارع التربية؟",
        a: "نعم. يمكن إعداد EquiSight بميزات التربية كدورة الفرس وتاريخ التلقيح ومراقبة الحمل وبيانات الحصان وشجرة النسب وتاريخ الولادة المتوقع وتطور المهر. هذا بالضبط هو المجال الذي تعجز عنه معظم التطبيقات المنافسة أو تتعامل معه بشكل محدود للغاية.",
      },
      {
        q: "هل يمكنني مشاركة البيانات مع مدربي أو بيطار الحوافر؟",
        a: "نعم. هدف EquiSight هو مشاركة المعلومات ذات الصلة بأمان مع الأشخاص من حول الخيل — المدرب وبيطار الحوافر وطبيب الأسنان والطبيب البيطري والمعالج الفيزيائي والمشرف أو المالك. يحصل كل شخص فقط على الصلاحيات اللازمة لدوره.",
      },
      {
        q: "لماذا لا أستخدم WhatsApp أو Excel فحسب؟",
        a: "يعمل WhatsApp و Excel طالما الأمور بسيطة. بمجرد أن تمتلك عدة خيول ومواعيد ووثائق وعلاجات وملّاكاً وبيانات تربية، تصبح الأمور عرضة للأخطاء: تتشتت المعلومات ويستغرق البحث وقتاً وتختفي الاتفاقيات الشفهية. يجمع تطبيق إدارة الخيول كل شيء لكل خيل مع تذكيرات تلقائية.",
      },
      {
        q: "كم يكلف EquiSight؟",
        a: "يمكنك البدء مجاناً بخيل واحد. إن أردت إدارة عدة خيول أو تفعيل وحدة التربية أو منح المتخصصين وصولاً، فتتوفر خطط Premium بأسعار معقولة. اطّلع على الخيارات الحالية في صفحة الأسعار.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "برامج تربية الخيول: مقارنة شاملة 2026",
      description: "قارن برامج تربية الخيول: دورة الفرس، الحمل، اختيار الفحل وتسجيل المهر. اكتشف لماذا يُعدّ EquiSight التطبيق الأكمل لتربية الخيول.",
      keywords: [
        "برامج تربية الخيول",
        "تطبيق دورة الفرس",
        "تطبيق حمل الفرس",
        "تطبيق تسجيل المهر",
        "تطبيق سجل النسب",
        "تخطيط التغطية للخيل",
        "تطبيق اختيار الفحل",
      ],
    },
    hero: {
      eyebrow: "دليل الاختيار · برامج تربية الخيول",
      breadcrumbLabel: "برامج تربية الخيول",
      title: "برامج تربية الخيول: المقارنة الشاملة لعام 2026.",
      intro: "تستحق فرس التربية أكثر من تطبيق عام لإدارة الخيول. قارن ميزات التربية في أشهر الأدوات، اكتشف ما يجب أن تُولِيه اهتمامك حقًا، واختر بوعي البرنامج المناسب لمزرعة الخيول الخاصة بك — صغيرة كانت أم كبيرة.",
      pills: [
        {
          icon: "Baby",
          label: "دورة الفرس",
        },
        {
          icon: "Heart",
          label: "متابعة الحمل",
        },
        {
          icon: "Sparkles",
          label: "نمو المهر",
        },
        {
          icon: "FileText",
          label: "سجل النسب",
        },
      ],
      ctas: [
        {
          label: "ابدأ مجانًا بوحدة التربية",
          href: "#start",
          primary: true,
        },
        {
          label: "إلى جدول المقارنة",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "لماذا لا يكفي تطبيق إدارة الخيول العادي لأغراض التربية.",
      lead: "معظم تطبيقات رياضة الخيل مصمَّمة لفرس رياضية أو ترفيهية واحدة. للتربية إيقاع مختلف كليًا: الشياع، التلقيح، متابعة الحمل، الفحوصات بالموجات فوق الصوتية، تقويم المهر، شجرة النسب والبيع. جدول Excel واحد يفقد توازنه بعد موسمين — وعند تربية عدة أفراس تفقد السيطرة.",
      items: [
        "متى كانت آخر دورة لـ بونيتا؟",
        "أي فحل مخطط له للتغطية في الموسم القادم؟",
        "هل تم جدولة الفحص بالموجات فوق الصوتية بعد 21 يومًا؟",
        "أي مهور 2024 تم بيعها بالفعل؟",
        "أين مخطط شجرة النسب حتى الجد من جهة الأم؟",
        "أين عينات الحمض النووي وبيانات جوازات السفر؟",
      ],
    },
    what: {
      title: "ما هي برامج تربية الخيول؟",
      lead: "برامج تربية الخيول هي ملف متخصص لكل فرس وفحل، مقترن بتقويم موسم التربية، وتخطيط الحمل، وتسجيل المهر، وعرض شجرة النسب. ليست مجرد سجل عام للخيول، بل أداة تفهم دورة التربية: من أول شياع حتى الفطام.",
      targetGroupsTitle: "لأي نوع من المربين تُناسب برامج التربية؟",
      targetGroups: [
        {
          icon: "Baby",
          title: "المربي الهاوي (1-3 أفراس)",
          body: "تغطية واحدة أو اثنتان في السنة — نظرة عامة دون التعقيد مع جداول Excel.",
        },
        {
          icon: "Building2",
          title: "مزرعة صغيرة (4-10 أفراس)",
          body: "خطة موسم التربية مع دورات التلقيح وفحوصات الحمل وملفات المهر.",
        },
        {
          icon: "Users",
          title: "مزرعة احترافية (10+)",
          body: "موظفون متعددون، اختيار الفحل لكل فرس، البيع والتسويق.",
        },
        {
          icon: "Target",
          title: "مربي الفحول",
          body: "سجل الطلبات وإحصاءات السائل المنوي والأجندة لكل فحل.",
        },
        {
          icon: "Heart",
          title: "زرع الأجنة",
          body: "ملف مزدوج للفرس المانحة والمستقبِلة، وتقويم زرع الأجنة.",
        },
        {
          icon: "ClipboardList",
          title: "تسجيل النسب",
          body: "عينات الحمض النووي ووثائق جوازات السفر وبيانات شجرة النسب.",
        },
      ],
    },
    criteria: {
      title: "ما المعايير التي يجب أن تستوفيها برامج التربية الجيدة؟",
      lead: "ليست كل 'ميزة تربية' في تطبيق الخيول متماثلة. خمسة مجالات رئيسية يضيع فيها المربون وقتًا طويلًا — وحيث يُحدث البرنامج فارقًا حقيقيًا.",
      items: [
        {
          icon: "Calendar",
          title: "دورة الفرس والشياع",
          body: "سجل يومي، تنبؤ بالإباضة، استمرارية الدورة وتذكيرات تلقائية.",
        },
        {
          icon: "Heart",
          title: "التلقيح ومتابعة الحمل",
          body: "تواريخ التغطية والتلقيح، بيانات الفحل، الفحص بالموجات فوق الصوتية في 14 يومًا و21 يومًا و60 يومًا وتحديد الجنس.",
        },
        {
          icon: "Baby",
          title: "نمو المهر",
          body: "بيانات الولادة، منحنى الوزن، جدول إزالة الطفيليات، موعد الفطام، تسجيل جواز السفر.",
        },
        {
          icon: "FileText",
          title: "شجرة النسب والوثائق",
          body: "عرض شجرة النسب حتى 4-5 أجيال، الحمض النووي، أرقام جوازات السفر وحالة تسجيل النسب.",
        },
        {
          icon: "Target",
          title: "اختيار الفحل والمطابقة",
          body: "التصفية حسب التخصص والخطوط وبيانات الفحل والنجاحات التاريخية — وليس فقط ما يروّج له مربي الفحل.",
        },
        {
          icon: "Share2",
          title: "التعاون مع الطبيب البيطري/المُلقِّح",
          body: "مشاركة الفحوصات والعينات والحالات مباشرةً مع العيادة التي تعمل مع أفراسك.",
        },
      ],
    },
    comparison: {
      title: "EquiSight مقابل برامج تربية الخيول الأخرى.",
      lead: "غالبًا ما تُظهر نتائج البحث الهولندية لبرامج تربية الخيول تطبيقات عامة تُشير إلى التربية في جملة واحدة. نُجري مقارنة أمينة لأدوات تمتلك فعلًا سير عمل تربية متكاملة.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "بداية مجانية",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "تسجيل دورة الفرس",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "تاريخ التلقيح + الفحل",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "الفحوصات ومتابعة الحمل",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "تاريخ الولادة المتوقع",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "ملف المهر (الوزن/النمو)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "شجرة النسب حتى 4-5 أجيال",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "تسجيل الحمض النووي وجواز السفر",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "اختيار الفحل / المطابقة",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "زرع الأجنة",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "نظرة عامة على أفراس متعددة",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "الجوال (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "المشاركة مع الطبيب البيطري",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "متكامل مع الملف العام",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "بيع وتسويق المهور",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "المقارنة مبنية على الميزات المتاحة للعموم في يناير 2026. EquineGenie قوي في التربية، لكنه أقل كفاءة في التطبيق المحمول وإدارة الخيول العامة. EquiSight يجمع بين الاثنين.",
    },
    why: {
      title: "لماذا يتعامل EquiSight مع المربين بشكل مختلف.",
      lead: "يعمل كثير من المربين ببرنامج تربية منفصل وتطبيق إدارة خيول مستقل. EquiSight يجمع الاثنين — دون التبديل بين التطبيقات أو إدخال البيانات مرتين.",
      points: [
        {
          icon: "Heart",
          title: "فرس التربية تبقى حصانًا عاديًا أيضًا",
          body: "لفرس التربية ملف موسم تربية وملف حصان عادي — الصحة، التطعيمات، البيطار. تطبيق واحد، جميع الوحدات.",
        },
        {
          icon: "Sparkles",
          title: "استباقي لا تفاعلي",
          body: "تنبؤ بالدورة، تذكيرات بمعالم الحمل وتقويم المهر — تلقائيًا بناءً على بياناتك.",
        },
        {
          icon: "Share2",
          title: "الجميع حول عملية التربية",
          body: "المُلقِّح، مربي الفحل، الطبيب البيطري، المشتري، سجل النسب — جميعهم يصلون بالصلاحيات المناسبة.",
        },
      ],
    },
    nicheA: {
      eyebrow: "لكل تخصص · من الدورة حتى الفطام",
      title: "ما يحتويه ملف التربية في EquiSight.",
      lead: "تحصل كل فرس على ملف تربية كامل مرتبط بملف الحصان العادي.",
      items: [
        "سجل الدورة اليومي مع التنبؤات",
        "التلقيح/التغطية + بيانات الفحل",
        "جدول زمني للفحوصات بالموجات فوق الصوتية (14/21/60 يومًا + الجنس)",
        "معالم الحمل مع تذكيرات تلقائية",
        "تاريخ الولادة المتوقع والتحضيرات",
        "ملف المهر من الولادة",
        "شجرة النسب حتى الأجداد بتنقل بالنقر",
        "عينة الحمض النووي، جواز السفر، حالة تسجيل النسب",
        "خط أنابيب البيع مع قائمة المهتمين",
        "سجل اختيار الفحل لكل فرس",
      ],
      ctaLabel: "اعرض وحدة التربية",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "للمزرعة بأكملها",
      title: "نظرة عامة على أفراس وفحول متعددة.",
      lead: "عندما تُربّي أكثر من فرسين أو ثلاثة، يصبح التحكم في جميع الدورات والحمل أمرًا بالغ الأهمية.",
      cards: [
        {
          t: "لوحة تحكم الدورات",
          d: "جميع الأفراس جنبًا إلى جنب مع مرحلة الدورة والإجراء التالي.",
        },
        {
          t: "خط أنابيب الحمل",
          d: "أي الأفراس في أي مرحلة من معالم الحمل؟",
        },
        {
          t: "تقويم المهور",
          d: "الولادات المتوقعة شهريًا مع اللوجستيات المنظمة.",
        },
        {
          t: "محفظة الفحول",
          d: "الفحول الخاصة أو المُلقِّحون الدائمون مع سجل الطلبات.",
        },
        {
          t: "مخطط شجرة النسب",
          d: "تحليل الأجداد عبر أجيال وخطوط متعددة.",
        },
        {
          t: "لوحة تحكم المبيعات",
          d: "أي المهور بِيعت، محجوزة أو لا تزال متاحة.",
        },
      ],
    },
    beforeAfter: {
      title: "من Excel والأجندة إلى EquiSight للتربية.",
      lead: "بشكل ملموس: هكذا يتغير موسم تربيتك.",
      rows: [
        {
          before: "الدورة في ملاحظة منفصلة",
          after: "سجل يومي مع تنبؤات",
        },
        {
          before: "الفحوصات عبر WhatsApp للمُلقِّح",
          after: "ملف مشترك مع الصور",
        },
        {
          before: "تاريخ الحمل في الأجندة",
          after: "تذكيرات تلقائية بالمعالم",
        },
        {
          before: "جواز سفر المهر في درج",
          after: "وثيقة مرتبطة بملف المهر",
        },
        {
          before: "شجرة النسب على ورق",
          after: "شجرة نسب قابلة للنقر حتى 4-5 أجيال",
        },
        {
          before: "إعلان بيع في Marktplaats",
          after: "خط أنابيب البيع مع قائمة الاهتمام",
        },
      ],
    },
    helper: {
      title: "أي برنامج تربية يناسبك؟",
      lead: "5 أسئلة لتحديد ما إذا كنت بحاجة إلى تطبيق تربية متكامل أو تكفيك أداة للهواة.",
      questions: [
        {
          id: "mares",
          q: "كم عدد أفراس التربية التي تديرها؟",
          options: [
            {
              label: "فرس واحدة",
              score: 1,
            },
            {
              label: "2-5 أفراس",
              score: 2,
            },
            {
              label: "أكثر من 5 أفراس",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "كم مرة تُربّي في السنة؟",
          options: [
            {
              label: "بشكل متقطع (كل بضع سنوات)",
              score: 0,
            },
            {
              label: "1-2 تغطية كل عام",
              score: 2,
            },
            {
              label: "3 تغطيات أو أكثر كل عام",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "كيف تُلقِّح / تُغطِّي؟",
          options: [
            {
              label: "تغطية طبيعية",
              score: 1,
            },
            {
              label: "تلقيح اصطناعي بسائل طازج/مبرد",
              score: 2,
            },
            {
              label: "زرع أجنة أو سائل مجمد",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "هل تتعاون مع طبيب بيطري/مُلقِّح؟",
          options: [
            {
              label: "شخص واحد ثابت",
              score: 1,
            },
            {
              label: "عيادات متعددة",
              score: 2,
            },
            {
              label: "شبكة دولية",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "ما الذي تتتبعه حاليًا؟",
          options: [
            {
              label: "Excel أو ورق",
              score: 1,
            },
            {
              label: "تطبيق عام لإدارة الخيول",
              score: 2,
            },
            {
              label: "لا شيء منظم",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "أداة للهواة أو Excel تكفي — لكن EquiSight يبقى مفيدًا.",
          body: "لفرس واحدة بتغطية طبيعية كل بضع سنوات، تُعدّ وحدة تربية متقدمة مبالغًا فيها. يبدأ EquiSight مجانًا وتُفعِّل وحدة التربية فقط للسنة التي تُغطي فيها — دون أي التزام بالترقية.",
          cta: "ابدأ مجانًا",
        },
        mid: {
          title: "EquiSight للتربية هو الأداة المناسبة.",
          body: "لديك أفراس متعددة أو طرق تربية متعددة — وهذا ما لم تُصمَّم له التطبيقات العامة للخيول. يجمع EquiSight بين التربية والرعاية العامة حتى لا تتنقل بين أداتين.",
          cta: "اعرض وحدة التربية",
        },
        high: {
          title: "EquiSight مُصمَّم لمزرعتك.",
          body: "أفراس متعددة، زرع أجنة أو سائل مجمد، فريق دولي — معظم الأدوات تقصر هنا. EquiSight يتوسع حتى مستوى المزرعة الاحترافية دون تراكم التراخيص الإضافية.",
          cta: "تحدث معنا حول خطة المزرعة الاحترافية",
        },
      },
    },
    faqTitle: "الأسئلة الشائعة حول برامج تربية الخيول",
    faq: [
      {
        q: "ما أفضل برنامج لتربية الخيول؟",
        a: "لفرس واحدة دون طريقة تربية معقدة، تكفي كثير من الأدوات. من 2-3 أفراس، أو عند استخدام التلقيح الاصطناعي أو زرع الأجنة، أو التعاون مع طبيب بيطري وسجل نسب، تصبح وحدة تربية متكاملة أمرًا بالغ الأهمية. يجمع EquiSight بين التربية وإدارة الخيول العامة في تطبيق واحد حتى لا تحتاج إلى التبديل.",
      },
      {
        q: "ما ميزات التربية التي أحتاجها فعلًا؟",
        a: "كحد أدنى: سجل الدورة، بيانات التلقيح/التغطية، معالم متابعة الحمل، وملف المهر. اختيارية لكنها قوية: عرض شجرة النسب، أرشيف اختيار الفحل، الحمض النووي/جواز السفر وخط أنابيب البيع.",
      },
      {
        q: "هل يمكن لـ EquiSight التنبؤ بدورة الفرس؟",
        a: "نعم. يستخدم EquiSight بيانات الدورات السابقة للتنبؤ بموعد الإباضة المتوقع، حتى تتمكن من تخطيط التلقيح أو التغطية في الوقت المناسب — دون الحاجة إلى التخمين يوميًا.",
      },
      {
        q: "هل يعمل EquiSight أيضًا مع زرع الأجنة؟",
        a: "نعم. تحصل الفرس المانحة والمستقبِلة على ملفات مرتبطة، وتقويم زرع الأجنة، ومعالم مشتركة مع العيادة. بذلك لا تفقد الجدول الزمني في سير عمل زرع الأجنة المعقد.",
      },
      {
        q: "هل يمكنني استيراد بيانات التربية الموجودة؟",
        a: "يمكنك إدخال الدورات والتغطيات وبيانات المهر يدويًا أو دفعةً واحدة عبر CSV. بالنسبة لمزارع التربية النشطة، نساعدك في عملية نقل بيانات لمرة واحدة إذا كان لديك بيانات تمتد لعدة مواسم.",
      },
      {
        q: "كيف أشارك الملف مع طبيبي البيطري أو المُلقِّح؟",
        a: "يحصل كل شخص على دور محدد: طبيب بيطري، مُلقِّح، مربي فحل أو مسؤول سجل النسب. يرى كل واحد فقط المعلومات اللازمة لدوره — دون الحاجة إلى وصول كامل.",
      },
    ],
  },
  manege: {
    seo: {
      title: "برامج إدارة مدارس الفروسية: مقارنة شاملة ودليل الاختيار 2026",
      description: "قارن بين برامج إدارة مدارس الفروسية للدروس والفرسان والخيول والإدارة. اكتشف التطبيق المناسب لمدرستك أو إسطبل الإيواء.",
      keywords: [
        "برنامج إدارة مدرسة الفروسية",
        "تطبيق إدارة الإسطبل",
        "برنامج إدارة مدرسة الخيل",
        "جدولة دروس الفروسية",
        "برنامج إسطبل الإيواء",
        "إدارة بيانات الفرسان",
        "إدارة بيانات الخيول في مدرسة الفروسية",
      ],
    },
    hero: {
      eyebrow: "دليل الاختيار · برامج مدارس الفروسية",
      breadcrumbLabel: "برامج مدارس الفروسية",
      title: "برامج إدارة مدارس الفروسية: الدليل الشامل لاختيار الأنسب لمدرستك وإسطبل الإيواء.",
      intro: "جدولة الدروس وإدارة الفرسان ورعاية الخيول والفوترة والتواصل — البرنامج الجيد لمدرسة الفروسية يجمع كل ذلك في مكان واحد. قارن بين أبرز الخيارات واكتشف أيها يناسب إسطبلك أو مدرستك.",
      pills: [
        {
          icon: "Calendar",
          label: "جدولة الدروس",
        },
        {
          icon: "Users",
          label: "الفرسان والعملاء",
        },
        {
          icon: "Heart",
          label: "رعاية الخيول",
        },
        {
          icon: "CreditCard",
          label: "الفوترة",
        },
      ],
      ctas: [
        {
          label: "اطلب عرضاً توضيحياً",
          href: "#start",
          primary: true,
        },
        {
          label: "إلى جدول المقارنة",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "لماذا تُبطئ الأدوات المتفرقة عمل مدرسة الفروسية؟",
      lead: "معظم مدارس الفروسية تعمل بطريقة مرقعة: جدولة الدروس على لوح أبيض، تسجيل الفرسان في Excel، الفوترة في أداة منفصلة، رعاية الخيول عبر WhatsApp والتواصل مع أصحاب الخيول برسائل شخصية. في الأسابيع المزدحمة تنشأ حجوزات مزدوجة وفواتير منسية وخيول لا يُعرف أي فارس سيركبها.",
      items: [
        "من يحضر الآن درس ياسمين؟",
        "أي فارس لم يدفع بعد رسوم شهر مارس؟",
        "أي حصان لا يجب استخدامه هذا الأسبوع؟",
        "من هم جهات الطوارئ للطلاب؟",
        "هل استلم صاحب ستارداست فاتورة بيطري الحوافر؟",
        "أي حصان في أي خانة؟",
      ],
    },
    what: {
      title: "ما هو برنامج إدارة مدرسة الفروسية؟",
      lead: "يجمع برنامج مدرسة الفروسية جدولةَ الدروس وإدارةَ الفرسان ورعايةَ الخيول والفوترةَ والتواصلَ في أداة واحدة. لا مزيد من التعقيدات في Excel أو الفوضى عبر WhatsApp، بل مكان واحد تعمل فيه المدرسة ويتابع منه الأصحاب والفرسان.",
      targetGroupsTitle: "لأي نوع من الشركات يُخصص هذا البرنامج؟",
      targetGroups: [
        {
          icon: "Building2",
          title: "مدرسة فروسية صغيرة (1-15 حصاناً)",
          body: "التركيز على جدولة الدروس والمدفوعات — إدارة بلا صداع.",
        },
        {
          icon: "Users",
          title: "مدرسة فروسية متوسطة (15-40 حصاناً)",
          body: "عدة مدربين، جدولة دروس وجدول خيول وإدارة فرسان.",
        },
        {
          icon: "ClipboardList",
          title: "إسطبل كبير للفروسية والإيواء (+40)",
          body: "عمليات كاملة تشمل الفوترة والتغذية وجدولة بيطري الحوافر.",
        },
        {
          icon: "Heart",
          title: "إسطبل الإيواء",
          body: "بوابة الأصحاب، تعليمات رعاية فردية، جدول مشترك.",
        },
        {
          icon: "Target",
          title: "إسطبل تدريب القفز",
          body: "جدولة البطولات، التدريب لكل حصان، التواصل مع العملاء.",
        },
        {
          icon: "FileText",
          title: "رواد الأعمال الفروسية",
          body: "مزيج من الدروس والإيواء والعيادات والتجارة — كل شيء من نظام واحد.",
        },
      ],
    },
    criteria: {
      title: "ما المعايير التي يجب أن يستوفيها برنامج مدرسة الفروسية الجيد؟",
      lead: "التطبيق الجميل لا يعني شيئاً إن لم يرغب موظفوك في استخدامه. خمسة معايير عملية تصنع الفرق بين النجاح والإحباط.",
      items: [
        {
          icon: "Calendar",
          title: "جدولة الدروس على مستويات متعددة",
          body: "مبتدئ/متقدم، دريساج/قفز، ربط الخيول بالفرسان وجداول المدربين — كل شيء مرئي جنباً إلى جنب.",
        },
        {
          icon: "Users",
          title: "إدارة بيانات الفرسان",
          body: "ملفات تعريفية، المستوى، الاشتراك، بطاقة الدروس وربط أفراد العائلة للفرسان الشباب.",
        },
        {
          icon: "Heart",
          title: "جدول الخيول",
          body: "كم مرة يُستخدم كل حصان، مع فترات الراحة والإصابات والحالات الخاصة.",
        },
        {
          icon: "CreditCard",
          title: "الفوترة والاشتراكات",
          body: "اشتراكات شهرية، بطاقات دروس، دروس منفردة وخصم تلقائي.",
        },
        {
          icon: "Share2",
          title: "بوابة الأصحاب (إسطبل الإيواء)",
          body: "يرى الأصحاب حصانهم في تطبيقهم الخاص — الجدول والتكاليف وبيطري الحوافر والملاحظات دون اتصال هاتفي.",
        },
        {
          icon: "Bell",
          title: "التواصل والتذكيرات",
          body: "تذكيرات الدروس التلقائية وإشعارات المدفوعات وإعلانات بيطري الحوافر — دون إرسال رسائل.",
        },
      ],
    },
    comparison: {
      title: "EquiSight مقابل برامج مدارس الفروسية الأخرى.",
      lead: "كثير من أدوات مدارس الفروسية قوية في جدولة الدروس أو الفوترة، لكنها نادراً ما تجمع بين رعاية الخيول والتواصل مع الأصحاب. نضعها جنباً إلى جنب بصدق.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "بداية مجانية / فترة تجريبية",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "جدولة الدروس",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "عدة مدربين",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "إدارة بيانات الفرسان",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "جدول الخيول",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "رعاية الخيول (تطعيمات/بيطري الحوافر)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "بطاقة دروس / اشتراك",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "المدفوعات الإلكترونية",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "الفوترة التلقائية",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "بوابة الأصحاب (إيواء)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "تكامل بيطري الحوافر/الطبيب البيطري",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "تذكيرات WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "تطبيق جوال (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "جدولة البطولات",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "مناسب لإسطبل الإيواء",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "المقارنة مبنية على الميزات المتاحة للعموم في يناير 2026. Stalmanager قوي في الإدارة، بينما يتميز EquiSight في سير عمل إسطبل الإيواء ورعاية الخيول وبوابة الأصحاب.",
    },
    why: {
      title: "لماذا يختلف EquiSight لمدارس الفروسية وإسطبلات الإيواء؟",
      lead: "يذهب EquiSight إلى أبعد من مجرد جداول الدروس. نرى مدرسة الفروسية كعملية متكاملة: خيول وأشخاص وتواصل وأموال — كل شيء مترابط.",
      points: [
        {
          icon: "Heart",
          title: "الحصان في المركز لا الجدول",
          body: "لكل حصان ملفه الخاص. استخدامه في الدروس وصحته وبيطري الحوافر والبطولات في جدول زمني واحد — لا ثلاثة أدوات منفصلة.",
        },
        {
          icon: "Share2",
          title: "الأصحاب يتابعون دون اتصال هاتفي",
          body: "لأصحاب إسطبل الإيواء عرضهم الخاص: التكاليف والجدول والصور والملاحظات — يوفر 5-10 مكالمات هاتفية في الأسبوع.",
        },
        {
          icon: "Bell",
          title: "تواصل تلقائي",
          body: "تذكير الدرس وتذكير التطعيم والفاتورة — تلقائياً عبر التطبيق/البريد الإلكتروني/SMS. لا مزيد من إرسال WhatsApp الجماعي.",
        },
      ],
    },
    nicheB: {
      eyebrow: "لإسطبل الإيواء",
      title: "ما الذي يحصل عليه إسطبل الإيواء من EquiSight.",
      lead: "لإسطبلات الإيواء تحديات فريدة لا تحلها برامج مدارس الفروسية العادية.",
      cards: [
        {
          t: "بوابة الأصحاب",
          d: "كل صاحب يرى حصانه (أو خيوله) وجدوله وتكاليفه فقط.",
        },
        {
          t: "تعليمات الرعاية لكل حصان",
          d: "العلف والأعلاف الخشنة والمكملات الغذائية وجدول البطانيات — مرئية لفريق الإسطبل.",
        },
        {
          t: "جدول مشترك",
          d: "بيطري الحوافر والطبيب البيطري وزيارات الأصحاب في عرض واحد.",
        },
        {
          t: "تكاليف الاستهلاك لكل حصان",
          d: "الفراش والعلف والأعلاف المركزة محسوبة ومُحالة لكل صاحب.",
        },
        {
          t: "جهات طوارئ الحصان",
          d: "الصاحب والطبيب البيطري وبيطري الحوافر دائماً في متناول فريق الإسطبل.",
        },
        {
          t: "إدارة الإجازات",
          d: "أي خيول ستذهب إلى المرعى أو الراحة أو إعادة التأهيل؟",
        },
      ],
    },
    beforeAfter: {
      title: "من اللوح الأبيض وExcel إلى EquiSight.",
      lead: "بشكل ملموس: هكذا تتغير أسبوع العمل في مدرسة الفروسية.",
      rows: [
        {
          before: "لوح أبيض لجدول الدروس",
          after: "جدولة حية لكل مدرب",
        },
        {
          before: "Excel للفرسان وملاحظات الدروس",
          after: "نظام CRM للعملاء مع سجل الدروس",
        },
        {
          before: "رسائل WhatsApp للأصحاب",
          after: "بوابة الأصحاب لمتابعة حصانهم",
        },
        {
          before: "خصم شهري يدوي",
          after: "فوترة تلقائية + iDEAL",
        },
        {
          before: "رعاية الخيول على لوحة إشعارات ورقية",
          after: "تعليمات رعاية لكل حصان مشتركة",
        },
        {
          before: "اتفاق شفهي مع بيطري الحوافر",
          after: "جدولة بيطري الحوافر مع تأكيدات",
        },
      ],
    },
    helper: {
      title: "أي برنامج لمدرسة الفروسية يناسبك؟",
      lead: "5 أسئلة لمعرفة ما إذا كان EquiSight هو المنصة المثالية لمدرستك أو إسطبل الإيواء.",
      questions: [
        {
          id: "size",
          q: "كم عدد الخيول في مشروعك؟",
          options: [
            {
              label: "أقل من 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "أكثر من 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "ما هو نشاطك الرئيسي؟",
          options: [
            {
              label: "تقديم الدروس بشكل رئيسي",
              score: 1,
            },
            {
              label: "إسطبل إيواء (خيول في الإيواء)",
              score: 3,
            },
            {
              label: "مزيج من الدروس والإيواء",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "كم عدد المدربين الذين تعمل معهم؟",
          options: [
            {
              label: "أنا فقط",
              score: 1,
            },
            {
              label: "2-3 مدربين",
              score: 2,
            },
            {
              label: "4 أو أكثر",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "كيف تدير فوترتك حالياً؟",
          options: [
            {
              label: "يدوياً (Word/Excel)",
              score: 3,
            },
            {
              label: "برنامج محاسبة منفصل",
              score: 2,
            },
            {
              label: "مدمج في أداة الدروس",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "كيف تتواصل مع أصحاب الخيول؟",
          options: [
            {
              label: "شخصياً / WhatsApp",
              score: 3,
            },
            {
              label: "بريد إلكتروني + WhatsApp",
              score: 2,
            },
            {
              label: "بوابة الأصحاب في الأداة",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "أداة خفيفة أو Excel قد تكفي الآن — لكن EquiSight ينمو معك.",
          body: "لمدرسة دروس صغيرة بمدرب واحد وإيواء محدود، لا تحتاج فوراً إلى حزمة متكاملة. EquiSight يبدأ مجاناً وينمو مع مدرستك — دون معاناة الترحيل بعد سنوات.",
          cta: "ابدأ مجاناً",
        },
        mid: {
          title: "EquiSight ترقية منطقية لمدرستك.",
          body: "عدة مدربين، مزيج من الدروس والإيواء، أو فوترة منفصلة حالياً — EquiSight يجمع كل ذلك في سير عمل واحد. بوابة الأصحاب بالذات توفر الكثير من التواصل العشوائي.",
          cta: "اطلب عرضاً توضيحياً",
        },
        high: {
          title: "EquiSight مصمم لحجم عملك.",
          body: "إسطبل الإيواء والدروس وعدة مدربين هو تحديداً ما يتميز فيه EquiSight عن أدوات مدارس الفروسية التقليدية. بوابة الأصحاب وتكامل رعاية الخيول يوفران ساعات أسبوعية من الإدارة والتواصل.",
          cta: "حدد موعد عرض لإسطبلك",
        },
      },
    },
    faqTitle: "أسئلة شائعة حول برامج مدارس الفروسية",
    faq: [
      {
        q: "ما هو أفضل برنامج لإدارة مدرسة الفروسية؟",
        a: "لجدولة الدروس البحتة توجد عدة خيارات جيدة. لكن حين تحتاج إلى إسطبل إيواء أو عدة مدربين أو تتبع رعاية الخيول، يصبح EquiSight الحل الشامل — لا تنقل بين الأدوات، كل شيء في مكان واحد.",
      },
      {
        q: "هل يمكنني استيراد العملاء والدروس الموجودة؟",
        a: "نعم. يمكن استيراد بيانات العملاء وجداول الدروس عبر CSV. نساعد مدارس الفروسية النشطة بترحيل لمرة واحدة حتى لا تضطر إلى إدخال 200 فارس يدوياً.",
      },
      {
        q: "هل يعمل أيضاً لإسطبل إيواء بلا دروس؟",
        a: "نعم. يتيح وضع إسطبل الإيواء إيقاف الدروس والتركيز على بوابة الأصحاب والتغذية والرعاية وجدولة بيطري الحوافر وإحالة التكاليف لكل حصان.",
      },
      {
        q: "هل يمكن للفرسان التسجيل والدفع بأنفسهم؟",
        a: "نعم. يمكن للفرسان عبر حساباتهم الخاصة رؤية الدروس المتاحة والتسجيل ودفع رسوم الدروس بـ iDEAL وشراء بطاقات الدروس.",
      },
      {
        q: "ما الوضع بالنسبة لخصوصية بيانات الخيول والأصحاب؟",
        a: "لكل شخص دور (صاحب، فارس، مدرب، موظف). يرى كل دور فقط ما يحتاج إليه. الأصحاب يرون حصانهم فقط، والفرسان يرون دروسهم الخاصة فقط.",
      },
      {
        q: "هل يمكن لـ EquiSight الربط ببرنامج المحاسبة الخاص بي؟",
        a: "نعم، تتوفر تكاملات مع Exact وMoneybird وe-Boekhouden. تتدفق الفواتير حينئذٍ تلقائياً إلى نظام محاسبتك.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "تطبيق المدرب للخيول: مقارنة ودليل الاختيار للمدربين 2026",
      description: "قارن تطبيقات المدربين للخيول والفرسان: سجل التدريب، الفيديو، الأهداف، تحليل البروتوكول وإدارة العملاء. اعثر على الأداة المناسبة للمدربين.",
      keywords: [
        "تطبيق مدرب الخيول",
        "تطبيق المدرب الخيالة",
        "تطبيق تدريب الخيول",
        "تطبيق تدريب الفرسان",
        "مفكرة تدريب الخيول",
        "تحليل بروتوكول الفروسية",
        "برنامج مدرب الخيول",
      ],
    },
    hero: {
      eyebrow: "دليل الاختيار · برنامج المدرب",
      breadcrumbLabel: "تطبيق المدرب",
      title: "تطبيق المدرب للخيول: دليل اختيار شامل للمدربين والمحترفين.",
      intro: "يتعامل المدرب أو المعلم مع مجموعات من الخيول والفرسان، والدروس، ومقاطع الفيديو، والأهداف، والمسابقات. قارن أفضل تطبيقات المدربين لعشاق الخيول واختر المنصة التي ستواكب نمو مسيرتك التدريبية حتى عام 2026 وما بعده.",
      pills: [
        {
          icon: "Target",
          label: "الأهداف والتخطيط",
        },
        {
          icon: "Video",
          label: "تحليل الفيديو",
        },
        {
          icon: "TrendingUp",
          label: "التقدم",
        },
        {
          icon: "Users",
          label: "العملاء/المجموعات",
        },
      ],
      ctas: [
        {
          label: "ابدأ مجاناً كمدرب",
          href: "#start",
          primary: true,
        },
        {
          label: "إلى جدول المقارنة",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "لماذا يعيق التدريب عبر WhatsApp المدربين؟",
      lead: "يعتمد معظم المدربين على أدوات متفرقة: WhatsApp للتواصل، ودفتر ملاحظات للدروس، وYouTube أو WeTransfer للفيديوهات، وExcel لنتائج المسابقات. يصلح هذا النظام مع 5 فرسان. أما مع 20 فارساً، فتضيع المعلومات وتُنسى الأهداف ويفقد المدرب السيطرة على تقدم كل فارس.",
      items: [
        "أين يوجد هدف أنوك لهذا الموسم؟",
        "أي فيديو أرسلته إلى براهم الشهر الماضي؟",
        "هل رأت لارا تحليل بروتوكول مسابقتها الأخيرة؟",
        "كم مرة يتدرب كل ثنائي في الأسبوع؟",
        "هل قرأ صاحب ستارداست تعليمات التدريب التي أرسلتها؟",
        "متى كانت آخر مرة أعطيت فيها ملاحظات حول الطاقة المتذبذبة؟",
      ],
    },
    what: {
      title: "ما هو تطبيق المدرب للخيول والفرسان؟",
      lead: "يجمع تطبيق المدرب نظام إدارة علاقات التدريب (الثنائيات، الدروس، الأهداف)، وسجل التدريب لكل خيل، وتغذية راجعة بالفيديو، وتخطيط المسابقات، وتحليل البروتوكول. لا مزيد من WhatsApp/YouTube/Excel المتفرقة، بل منصة واحدة يتعاون فيها المدرب والفارس معاً.",
      targetGroupsTitle: "لأي نوع من المدربين هو مخصص؟",
      targetGroups: [
        {
          icon: "Target",
          title: "مدرب الفروسية الكلاسيكية",
          body: "مسح البروتوكول، ربط تعليقات لجنة التحكيم بأهداف التدريب، ومتابعة التقدم.",
        },
        {
          icon: "Activity",
          title: "مدرب القفز",
          body: "تخطيط المسارات، تغذية راجعة على الجولات، إدارة الارتفاعات لكل خيل.",
        },
        {
          icon: "Award",
          title: "مدرب الفروسية الثلاثية",
          body: "ثلاثة تخصصات، ثلاثة خطط تدريب — كلها مرئية جنباً إلى جنب.",
        },
        {
          icon: "TrendingUp",
          title: "مدرب الأداء الرياضي",
          body: "تتبع EPI، والمسابقات، والأهداف — للرياضيين المحترفين وفرقهم.",
        },
        {
          icon: "Users",
          title: "مدرب الحلبة",
          body: "دروس جماعية وتدريب فردي في تطبيق واحد.",
        },
        {
          icon: "Heart",
          title: "مدرب الفروسية الترفيهية",
          body: "علاج بالخيول، المبتدئون، أصحاب الخيول الذين يمتلكون خيلاً واحداً.",
        },
      ],
    },
    criteria: {
      title: "ما المعايير التي يجب أن يستوفيها تطبيق المدرب الجيد؟",
      lead: "التدريب عمل إنساني في جوهره، لكن الأداة الصحيحة تجعلك أكثر كفاءة بنسبة 30-50% وتساعد الفرسان على التحسن حتى بين الدروس.",
      items: [
        {
          icon: "Users",
          title: "إدارة الثنائيات",
          body: "الخيل والفارس كوحدة واحدة، مع المستوى والأهداف والتقدم والسجل التاريخي.",
        },
        {
          icon: "ClipboardList",
          title: "ملاحظات الدروس والأهداف",
          body: "ملاحظة لكل درس مع نقاط التركيز، مرتبطة بالأهداف طويلة المدى.",
        },
        {
          icon: "Video",
          title: "تغذية راجعة بالفيديو",
          body: "رفع الفيديو، وتمييز اللحظات، وإضافة تغذية راجعة صوتية أو مكتوبة.",
        },
        {
          icon: "Target",
          title: "تحليل المسابقات والبروتوكول",
          body: "مسح البروتوكولات (KNHS/FEI)، وعرض الدرجات لكل عنصر، وتعليقات لجنة التحكيم والاتجاهات.",
        },
        {
          icon: "Calendar",
          title: "التخطيط وبطاقات الدروس",
          body: "الجدول الزمني، والمدفوعات، والاشتراكات، والتذكيرات التلقائية.",
        },
        {
          icon: "Share2",
          title: "التواصل مع الفارس",
          body: "يرى الفارس صفحته الخاصة بالدروس والفيديوهات والأهداف والتغذية الراجعة.",
        },
      ],
    },
    comparison: {
      title: "EquiSight مقابل تطبيقات المدربين الأخرى.",
      lead: "بعض أدوات المدربين تركز على استبدال WhatsApp، والبعض الآخر على تحليل البروتوكول. يجمع EquiSight بين الاثنين مع ملف خيل حقيقي — بحيث يتحسن الفارس أيضاً بين الدروس.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "بدء مجاني",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "إدارة الثنائيات",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "ملاحظات الدروس والتغذية الراجعة",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "أهداف طويلة المدى",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "رفع فيديو + تغذية راجعة",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "مسح بروتوكول KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (مؤشر الأداء)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "تقويم المسابقات",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "بوابة الفارس",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "بطاقة الدروس / الاشتراك",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "المدفوعات الإلكترونية",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ملف الخيل المتكامل",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "بيانار الحداد/البيطري مرئية",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "للمدرب والفارس معاً",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "خيول متعددة لكل فارس",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "المقارنة مبنية على الميزات المتاحة للعموم في يناير 2026. يتميز EquiSight بفرادته في تحليل البروتوكول + EPI ويجمعهما مع إدارة الخيول الشاملة.",
    },
    why: {
      title: "لماذا يقدم EquiSight تجربة تدريب مختلفة.",
      lead: "تنتهي معظم أدوات المدربين عند انتهاء الدرس. EquiSight يستمر — في ملف الخيل، وفي تحليل المسابقات، وفي التعاون مع البيطري والمالك.",
      points: [
        {
          icon: "TrendingUp",
          title: "مسح البروتوكول ← هدف التدريب",
          body: "امسح بروتوكول KNHS واعرف على الفور أي العناصر تحتاج إلى اهتمام. تظهر الأهداف تلقائياً.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach يعزز بصيرتك",
          body: "بيانات من دروس ومسابقات وبروتوكولات متعددة تكشف أنماطاً يصعب تتبعها في الذاكرة وحدها.",
        },
        {
          icon: "Share2",
          title: "متكامل مع الخيل",
          body: "يرى المدرب سجل التطعيمات والحداد والإصابات — لا تخطيط للتدريب في فترة التعافي.",
        },
      ],
    },
    nicheA: {
      eyebrow: "للفروسية الكلاسيكية والقفز",
      title: "ما يحتويه ملف التدريب في EquiSight.",
      lead: "يحصل كل ثنائي على سجل تدريبي شامل يجمع كل شيء في مكان واحد — لا مزيد من ضياع المعلومات في WhatsApp.",
      items: [
        "ملاحظات الدروس مع نقاط التركيز لكل جلسة",
        "أهداف طويلة المدى + معالم رئيسية",
        "رفع الفيديو مع تعليقات على الكود الزمني",
        "مسح بروتوكول KNHS/FEI مع الدرجات",
        "تعليقات لجنة التحكيم مرتبطة بالتدريب",
        "نتائج المسابقات واتجاه EPI",
        "بيانات التواصل مع العميل وسجل الدروس",
        "بطاقة الدروس / الاشتراك / الفواتير",
        "رسم بياني للتقدم لكل تخصص",
        "وصول مشترك مع مالك الخيل",
      ],
      ctaLabel: "استعرض وحدة المدرب",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "من WhatsApp + YouTube إلى EquiSight للمدربين.",
      lead: "بشكل ملموس: هكذا تتغير سير عمل التدريب.",
      rows: [
        {
          before: "WhatsApp مع روابط فيديو متفرقة",
          after: "فيديو مع تغذية راجعة بالكود الزمني في الملف",
        },
        {
          before: "دفتر ملاحظات لكل فارس",
          after: "سجل تدريبي مع الأهداف والتاريخ",
        },
        {
          before: "Excel مع نتائج المسابقات",
          after: "رسم بياني EPI + تحليل البروتوكول",
        },
        {
          before: "أهداف شفهية",
          after: "معالم رئيسية مع مؤشر التقدم",
        },
        {
          before: "أداة فوترة منفصلة",
          after: "الدروس + iDEAL + الاشتراك في التطبيق",
        },
        {
          before: "بريد إلكتروني للمالك عن التقدم",
          after: "يتابع المالك من خلال عرضه الخاص",
        },
      ],
    },
    helper: {
      title: "أي تطبيق مدرب يناسبك؟",
      lead: "5 أسئلة لمعرفة ما إذا كانت أداة التدريب المتخصصة ستضيف قيمة لممارستك.",
      questions: [
        {
          id: "clients",
          q: "كم عدد الثنائيات النشطة التي تدربها؟",
          options: [
            {
              label: "أقل من 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "أكثر من 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "ما هو تخصصك الرئيسي؟",
          options: [
            {
              label: "الفروسية الكلاسيكية",
              score: 3,
            },
            {
              label: "القفز",
              score: 2,
            },
            {
              label: "ترفيهي / متنوع",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "هل تستخدم الفيديو في التدريب؟",
          options: [
            {
              label: "نادراً",
              score: 0,
            },
            {
              label: "أحياناً (يدوياً)",
              score: 2,
            },
            {
              label: "كثيراً — بشكل منتظم",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "هل تدرب فرسان مسابقات؟",
          options: [
            {
              label: "لا، ترفيهي فقط",
              score: 0,
            },
            {
              label: "أحياناً في المسابقات",
              score: 2,
            },
            {
              label: "كثيراً — بطاقات البداية محورية",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "هل تريد قياس أداء تدريبك؟",
          options: [
            {
              label: "لا، الحدس يكفي",
              score: 0,
            },
            {
              label: "نعم، لكن لا وقت",
              score: 2,
            },
            {
              label: "نعم — تدريب مبني على البيانات",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "أداة بسيطة أو حتى WhatsApp تكفي — في الوقت الحالي.",
          body: "بالنسبة لأقل من 5 فرسان بدون فيديو أو مسابقات كثيرة، فإن تطبيق التدريب مبالغة. يبدأ EquiSight مجاناً، لذا يمكنك تجربته عندما تنمو ممارستك.",
          cta: "ابدأ مجاناً",
        },
        mid: {
          title: "EquiSight للمدربين يجعلك أكثر كفاءة بشكل منتظم.",
          body: "مع 5-15 ثنائياً، تخسر ساعات شهرياً بسبب WhatsApp والفيديوهات المتفرقة. يجمع EquiSight كل شيء، ويمسح البروتوكولات تلقائياً، ويضمن أن يتمكن الفرسان دائماً من مراجعة تغذيتهم الراجعة.",
          cta: "جرب وحدة المدرب",
        },
        high: {
          title: "EquiSight مصمم لحجم عملك التدريبي.",
          body: "عدد كبير من الفرسان، وفيديو، ومسابقات، وتدريب مبني على البيانات: هذا بالضبط ما يميز EquiSight. EPI + مسح البروتوكول + ملف الخيل يمنحانك ميزة تنافسية لا يملكها المنافسون.",
          cta: "احجز عرضاً توضيحياً لممارستك التدريبية",
        },
      },
    },
    faqTitle: "أسئلة شائعة حول تطبيقات المدربين",
    faq: [
      {
        q: "ما هو أفضل تطبيق مدرب للخيول والفرسان؟",
        a: "للتواصل البحت، تكفي كثير من الأدوات (حتى WhatsApp). أما للأهداف وتحليل الفيديو ومسح البروتوكول وتتبع المسابقات وإدارة العملاء في أداة واحدة، فإن EquiSight هو الحل الأكثر اكتمالاً — خاصةً لأنه يتتبع الخيل نفسه أيضاً، وليس فقط الثنائي.",
      },
      {
        q: "هل يمكن لـ EquiSight قراءة بروتوكولات المسابقات تلقائياً؟",
        a: "نعم. ارفع بروتوكول KNHS أو FEI ويستخرج EquiSight الدرجات لكل عنصر، وتعليقات لجنة التحكيم، ويربطها بالثنائي. يمكنك رؤية الاتجاهات عبر مسابقات متعددة.",
      },
      {
        q: "ما هو EPI (مؤشر أداء الفروسية)؟",
        a: "EPI هو درجة EquiSight التي تحوّل نتائج مسابقات متعددة إلى مؤشر أداء قابل للمقارنة. بذلك ترى التقدم الحقيقي عبر فئات وهيئات تحكيم مختلفة.",
      },
      {
        q: "هل يمكن للفرسان حجز الدروس والدفع بأنفسهم؟",
        a: "نعم. يسجّل الفرسان الدخول، ويرون الأوقات المتاحة، ويشترون بطاقات الدروس ويدفعون عبر iDEAL. أنت تتحكم في ما تريد تقديمه وتوافق أو ترفض.",
      },
      {
        q: "هل يعمل أيضاً لمدرب يعمل حول الحلبة؟",
        a: "نعم. يمكنك العمل كمدرب مستقل مع عملائك الخاصين دون ربط حساب حلبة. يدفع لك العملاء مباشرة.",
      },
      {
        q: "هل يمكنني نقل الفيديوهات والملاحظات الموجودة؟",
        a: "يمكنك رفع الفيديوهات لكل ثنائي أو عبر أداة رفع جماعي. استيراد الملاحظات عبر CSV. نساعد المدربين النشطين في عملية نقل بيانات لمرة واحدة.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "أدلة ومساعدات الاختيار لبرامج إدارة الخيول | EquiSight",
      description: "جميع أدلة EquiSight في مكان واحد: مقارنات برامج إدارة الخيول والتربية والمدارس والمدربين، بالإضافة إلى مساعدات الاختيار لعام 2026.",
      keywords: [
        "أدلة برامج الخيول",
        "مساعدة اختيار إدارة الخيول",
        "مقارنة برامج التربية",
        "دليل برامج مدارس الفروسية",
        "مقارنة تطبيقات المدربين",
      ],
    },
    hub: {
      eyebrow: "المحور · الأدلة",
      breadcrumbLabel: "الأدلة",
      title: "أربعة أدلة شاملة لاختيار برنامج الخيول المناسب.",
      intro: "مساعدة اختيار متعمقة لكل فئة مستخدمين: جداول مقارنة، ومعايير، وأمثلة، واختبار تفاعلي. انقر للوصول إلى الدليل الذي يناسب وضعك، أو استعرض أولاً المقالات التفصيلية تحت كل مجموعة.",
      stats: {
        guides: "4 مساعدات اختيار",
        articles: "15 مقالاً تفصيلياً",
        fair: "مقارنة موضوعية",
      },
      readMoreCta: "اقرأ الدليل الكامل",
      relatedHeading: "مقالات تفصيلية",
      articlesCountSingular: "{{count}} مقال تفصيلي",
      articlesCountPlural: "{{count}} مقالات تفصيلية",
      articlesCountAria: "عدد مقالات المجموعة",
      lastUpdatedPrefix: "تم التحديث",
      lastUpdatedAria: "تاريخ آخر تحديث لهذه المجموعة",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "مساعدة اختيار تطبيق إدارة الخيول",
        blurb: "قارن أشهر تطبيقات إدارة الخيول واكتشف أيها يناسب المالك أو الإسطبل أو مربي الخيول. يشمل جدول مقارنة موضوعي ومساعدة اختيار بـ5 أسئلة.",
        audience: "لأصحاب الخيول وأصحاب الإسطبلات وجميع عشاق الخيول الباحثين عن نظرة شاملة.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "مقارنة برامج تربية الخيول",
        blurb: "من دورة الفرس إلى تطور المهر: اكتشف أي برامج تربية الخيول تعمل فعلاً وفق عدد أفراسك وأسلوب التربية ومتطلبات السجل النسبي.",
        audience: "للمربين الهواة والمحترفين وأصحاب الإسطبلات ومربي الفحول.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "مساعدة اختيار برامج مدارس الفروسية",
        blurb: "جدولة الدروس وإدارة الفرسان وبوابة الملاك والفوترة — في أداة واحدة. قارن الخيارات المتاحة لمدارس الفروسية وإسطبلات الإيواء في 2026.",
        audience: "لمدارس الفروسية وإسطبلات الإيواء والشركات المتخصصة بالركوب.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "مساعدة اختيار تطبيق المدرب",
        blurb: "إدارة علاقات التدريب، والتغذية الراجعة بالفيديو، ومسح بروتوكولات KNHS، وتتبع الأهداف لكل ثنائي. أي تطبيق مدرب يناسب ممارستك في التدريب؟",
        audience: "للمعلمين والمدربين والمشرفين.",
      },
    ],
    closing: {
      eyebrow: "لماذا هذه الأدلة",
      title: "مقارنة موضوعية، لا مجرد مقارنة أسعار.",
      body1: "كثير من \"صفحات المقارنة\" ما هي إلا إعلانات مقنّعة. تضع أدلتنا الميزات والفئات المستهدفة والمنافسين جنباً إلى جنب كما تفعل مصادر المعرفة المستقلة. يبرز EquiSight بطبيعة الحال بوصفه الحل الشامل، لكنك ستقرأ أيضاً بصدق في أي المجالات تتفوق التطبيقات الأخرى.",
      body2: "تجيب المقالات التفصيلية تحت كل دليل على الأسئلة العملية الناجمة عن عملية الاختيار: «متى تُجرى أول صورة بالموجات فوق الصوتية بعد التلقيح؟»، «كيف أُؤتمت فوترة مدرسة الفروسية؟»، «كيف أُحلل بروتوكول المنافسة؟». لا مصطلحات تسويقية فارغة، بل ممارسة فعلية.",
    },
    hubName: "أدلة EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "لماذا يسبب هذا مشكلة",
      basics: "الأساسيات",
      criteria: "ما الذي يجعله جيداً؟",
      comparison: "مقارنة عادلة",
      why: "الفرق",
      beforeAfter: "من التشتت إلى الوضوح",
      helper: "5 أسئلة",
    },
    table: {
      feature: "الميزة",
      today: "اليوم",
      withEquisight: "مع EquiSight",
    },
    helper: {
      questionLabel: "السؤال {{current}} من {{total}}",
      answerPrompt: "أجب على السؤال المتبقي {{count}} لرؤية توصية.",
      answerPromptPlural: "أجب على الأسئلة المتبقية {{count}} لرؤية توصية.",
      resultEyebrow: "نتيجتك",
    },
    targetGroupsFallback: "لمن هذا مخصص؟",
    faqTitleFallback: "الأسئلة الشائعة",
  },
};

export default CORNERSTONES;
